import React from "react";
import "./Policy.css";

function Policy() {
  return (
    <div className="policy-content">
      
        <section id="policies">
            <h2>Our Policies</h2>
            <div class="policy" id="privacy-policy">
                <h3>Privacy Policy</h3>
                <p>At Detallitos Las Nieves, we respect your privacy and are committed to protecting your personal information.</p>
                <ul>
                    <li><strong>Information We Collect:</strong>
                        <ul>
                            <li><strong>Personal Information:</strong> We may collect your name, email address, or any other details you choose to provide when you contact us.</li>
                            <li><strong>Non-Personal Information:</strong> We may also collect information automatically about your visit to our website, such as your IP address, browser type, and time spent on the website.</li>
                        </ul>
                    </li>
                    <li><strong>How We Use Your Information:</strong>
                        <ul>
                            <li>We use the personal information you provide to communicate with you, send promotional emails, and improve our services. The non-personal data is used to analyze website performance and enhance the user experience.</li>
                        </ul>
                    </li>
                    <li><strong>Cookies</strong>
                     <ul>Our website uses cookies to improve functionality and provide a more personalized experience. You can control or disable cookies through your browser settings.</ul>
                    </li>
                    <li><strong>Data Protection:</strong>
                        <ul>
                            <li><strong>Security Measures:</strong> We take appropriate security measures to protect against unauthorized access to or unauthorized alteration, disclosure, or destruction of your personal information.</li>
                            <li><strong>Data Sharing:</strong> We do not share your personal information with any third parties.</li>
                        </ul>
                    </li>
                    <li><strong>Contact Us:</strong> If you have any questions or concerns about our privacy policy, please contact us at: <a href="mailto:parrillalasnieves@yahoo.es">parrillalasnieves@yahoo.es</a></li>
                </ul>
            </div>
            

            <div class="policy" id="health-safety-policy">
                <h3>Safety Policy</h3>
                <p><strong>Safety Measures:</strong> We adhere to strict hygiene practices to ensure the safety and well-being of our customers and staff.</p>
               
            </div>
          
            <div class="policy" id="payment-policy">
                <h3>Payment Policy</h3>
                <p><strong>Accepted Payment Methods:</strong> We accept all major credit and debit cards. Cash payments are also accepted.</p>
            </div>
            <div class="policy" id="company-info">
                <h3>Company Information</h3>
                <p><strong>Company Details:</strong></p>
                <ul>
                    <li><strong>Name:</strong> Explotaciones Mendoza y Rodríguez S.L.</li>
                    <li><strong>NIF / CIF:</strong> B76595545</li>
                    <li><strong>Address:</strong> Carretera las Nieves, 17, 38700 Santa Cruz de la Palma, Santa Cruz de Tenerife, Spain</li>
                    <li><strong>Email:</strong> <a href="mailto:detallitoslasnieves@outlook.es">detallitoslasnieves@outlook.es</a></li>
                </ul>
            </div>
        </section>
    
  </div>
  );
}

export default Policy;